import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceStore } from '@y42/datasource';
import { IntegrationGitFactoryService } from './integration-git-factory.service';
import { IntegrationState } from './integration.model';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'integration', idKey: '$path' })
export class IntegrationStore extends DatasourceStore<IntegrationState> {
  constructor(protected readonly gitFactory: IntegrationGitFactoryService) {
    super('Integration', gitFactory);
  }
}
